import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['María González', 'Juan Pérez', 'Carolina Méndez', 'Martín Rodríguez', 'Lucía Fernández', 'Pablo Sánchez', 'Valentina López', 'Diego Ramírez', 'Florencia Torres', 'Andrés Gutiérrez', 'Camila Ruiz', 'Sebastián Morales'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'La Plata', 'San Juan', 'Salta', 'Neuquén', 'Bahía Blanca', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = [useState(false)[0], useState(false)[1]]; // Using array destructuring to avoid unused setter warning if not used directly, but we need it.
  const [visible, setVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
      // Then set interval every 15-25 seconds
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 10000) + 15000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-268">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white rounded-xl shadow-2xl border border-slate-100 p-4 flex items-start gap-4" data-id="element-269">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-270">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-271" />
          </div>
          <div data-id="element-272">
            <p className="text-sm font-medium text-slate-600 mb-1" data-id="element-273">
              <span className="font-bold text-slate-900" data-id="element-274">
                {currentData.name}
              </span>{' '}
              de {currentData.city}
            </p>
            <p className="text-sm font-bold text-[#0D7377]" data-id="element-275">
              Acaba de comprar el Sistema PRO
            </p>
            <p className="text-xs text-slate-400 mt-1" data-id="element-276">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}